import React, { useEffect, useRef, useState } from "react";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import axios from "axios";
import { useParams } from "react-router-dom";
import Loader from "./Loader";
import ReactTost from "./ReactTost";
import { useTranslation } from "react-i18next";
import DOMPurify from 'isomorphic-dompurify';
import { marked } from 'marked';

const FreeChatbot = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isLoading, ] = useState(false);
  const { id } = useParams();
  const API_URL = process.env.REACT_APP_API_URL;
  const API_VERSION = process.env.REACT_APP_API_VERSION;
  const chatContainerRef = useRef(null);
  const chatMessageRef = useRef(null);
  const [sid, setSid] = useState();
  const [message, setMessage] = useState();
  const[headerLogo,setHeaderLogo]=useState();
  const [chatHistoryData, setChatHistoryData] = useState([]);
  const [isFirst, setIsFirst] = useState(true);
  const [color, setColor] = useState("#05204a");
  const [, setName] = useState();
  const [initialMsg, setInitialMsg] = useState();
  const [messageToChat, setMessageToChat] = useState(false);
  const [, setVisibility] = useState();
  const [suggestedQuestion, setSuggestedQuestion] = useState([]);
  const [messageType, setMessageType] = useState();
  const [, setMessageCount] = useState(0);
  const [messageTime, setMessageTime] = useState(0);
  const [, setUpdateId] = useState(0);
  const [, setLimit] = useState();
  const [, setSeconds] = useState();
  const [type, setType] = useState("");
  const [showAlert, setShowAlert] = useState(false)
  const [, setErrorDisplay] = useState();
  const [perUserErrorDisplay, setPerUserErrorDisplay] = useState(false);

  const [perUserError, ] = useState(
    "Sorry, I have a limit of Questions per visitor per day. Please come back later"
  );

  const [isDisable, setIsDisable] = useState(false);
  useEffect(() => {
    const getSid = () => {
      axios
        .get(`${API_URL}/${API_VERSION}/bot/init/${id}`)
        .then((response) => {
          if (response.data) {
            if (response.data.sid) {
              localStorage.setItem(id, response.data.sid);
              setSid(response.data.sid);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

    if (id) {
      const sidList = localStorage.getItem(id);
      setSid(sidList);
      if (!sidList) {
        getSid();
      }
    }
  }, [API_URL, API_VERSION, id]);

  async function userQuestion() {
    let isNew = 1;
    let isKey = chatHistoryData.length;
    let __msg__ = "";
    await fetchEventSource(
      `${process.env.REACT_APP_STRING_CHAT_URL}/bot/query-stream/${id}?text=${message}&sid=${sid}`,
      {
        method: "GET",
        headers: {
          Accept: "text/event-stream",
        },
        onopen(res) {
          if (res.ok && res.status === 200) {
            console.log("Connection made ", res);
          } else if (
            res.status >= 400 &&
            res.status < 500 &&
            res.status !== 429
          ) {
            console.log("Client side error ", res);
          }
        },
        onmessage(event) {
          const messageText = JSON.parse(event.data).token;
          if (messageText !== "[END]") {
            __msg__ = __msg__ + messageText;
            const userMessage = (
              <li className="sender chatGPTreplay">
                <div className="cont">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(
                        marked.parse(__msg__)
                      ),
                    }}
                  ></span>
                </div>
              </li>
            );
            if (isNew) {
              isNew = false;
              setChatHistoryData((prevHistory) => [
                ...prevHistory,
                userMessage,
              ]);
            } else {
              setChatHistoryData((prevHistory) => {
                const updatedHistory = [...prevHistory];
                updatedHistory[parseInt(isKey + 1)] = userMessage;
                return updatedHistory;
              });
            }
          }
        },
        onclose() {
          console.log("Connection closed by the server");
        },
        onerror(err) {
          console.log("There was an error from server", err);
        },
      }
    );
  }

  function callQuestion() {
    CheckUSerMessageLimit()
    .then(async (response) => {
        setIsDisable(() => true);
      if (response) {
        setPerUserErrorDisplay(false);
          chatMessageRef.current.value = "";
          if (sid && message) {
            const userMessage = (
              <li className="repaly userInput" style={{ background: color }}>
                <div className="cont">
                  <span>{message}</span>
                </div>
              </li>
            );
            setChatHistoryData((prevHistory) => [...prevHistory, userMessage]);
            setMessageToChat(false);
            await userQuestion();
          }
        } else {
          setPerUserErrorDisplay(true);
        }
        setIsDisable(() => false);
        return false;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleKeyPress(e) {
    e.preventDefault();
    callQuestion();
    return false;
  }

  function checkMessageLimit() {
    setLoading(true);
    let sID = sid;
   
    axios.post(`${API_URL}/${API_VERSION}/bot/checkMessageLimit/${id}`, {
      sID,
    },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      }
    ).then((response) => {
      console.log(response)
      setLoading(false);
      if (response.data.ans === true) {
        console.log("calling question api")
        callQuestion();
      } else {
        setType("Danger");
        setMessage(t("Message limit exceeded."));
        setShowAlert(true);
      }
    })
      .catch((error) => {
        setLoading(false);
        setType("Danger");
        setMessage(t("Something went wrong."));
        setShowAlert(true);
      });
  }

  // useEffect(() => {
  //   if (chatContainerRef && chatContainerRef.current) {
  //     chatContainerRef.current.addEventListener("DOMNodeInserted", (event) => {
  //       const { currentTarget: target } = event;
  //       target.scroll({ top: target.scrollHeight, behavior: "smooth" });
  //     });
  //   }
  // }, [chatHistoryData]);
  useEffect(() => {
    const container = chatContainerRef?.current;
    if (!container) return;
  
    const observer = new MutationObserver(() => {
      container.scroll({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    });
  
    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  
    return () => observer.disconnect();
  }, [chatHistoryData]);

  async function CheckUSerMessageLimit() {
    if (sid) {
      const messageCountResponse = await axios.post(
        `${API_URL}/${API_VERSION}/bot/checkMessageLimit/${id}`,
        {
          sID: sid,
          time: messageTime,
        }
      );
      return messageCountResponse.data.ans;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (isFirst) {
      setIsFirst(false);
      axios
        .get(`${API_URL}/${API_VERSION}/bot/chatbot/${id}`)
        .then((response) => {
          if (response.data) {
            setVisibility(response.data.settings.visibility);
            setMessageCount(response.data.settings.messageCount);
            setMessageTime(response.data.settings.messageLimit);
            if (response.data.chatInterface) {
              setMessageType(response.data.chatInterface.messageType);
              setColor(response.data.chatInterface.color);
              setInitialMsg(response.data.chatInterface.initialMsg);
              setName(response.data.chatInterface.name);
              if (response.data.chatInterface.suggestedMsg) {
                setSuggestedQuestion(
                  response.data.chatInterface.suggestedMsg.split("\n")
                );
              }
              setHeaderLogo(response.data.chatInterface.headerLogo);
              const _userMessage = (
                <li className="sender chatGPTreplay">
                  <div className="cont">
                    <span>{response.data.chatInterface.initialMsg}</span>
                  </div>
                </li>
              );
              setChatHistoryData([]);
              setChatHistoryData((_prevHistory) => [
                ..._prevHistory,
                _userMessage,
              ]);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .get(`${API_URL}/${API_VERSION}/rateLimit`, {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          if (response.data.length) {
            setLimit(response.data[0].maxQuestion);
            setSeconds(response.data[0].msgLimit);
            setErrorDisplay(response.data[0].msgErr);
            setUpdateId(response.data[0].id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [API_URL, API_VERSION, id, isFirst]);

  function resetChatUi() {
    const _userMessage = (
      <li className="sender chatGPTreplay">
        <div className="cont">
          <span>{initialMsg}</span>
        </div>
      </li>
    );
    setChatHistoryData([]);
    setChatHistoryData((_prevHistory) => [..._prevHistory, _userMessage]);
  }

  useEffect(() => {
    if (messageToChat && message) {
      callQuestion();
    }
  }, [messageToChat, message]);

  const buttonStyle = {
    pointerEvents: isDisable ? "none" : "auto",
  };

  return (
    <>
      <section className="chating_bot_web">
      <ReactTost
          onHide={() => {
            setShowAlert(false);
            setType("");
            setMessage("");
          }}
          alertClass={type}
          alertMessage={message}
          alertDo={showAlert}
        />
        <div className="chatingwrap">
          <div className="chating_head" style={{ color: color }}>
            <div className="brand" style={{ color: color }}>
              <div className="icon">
                <img src={headerLogo? headerLogo: "https://seekicon.com/free-icon-download/chat_7.svg"}alt=""/>
              </div>
            </div>
            <div className="refresh" onClick={() => resetChatUi()}>
              <i className="fa-solid fa-rotate"></i>
            </div>
          </div>
          <div className="chating_area" ref={chatContainerRef}>
            {loading ? <Loader /> : <ul>{chatHistoryData}</ul>}
          </div>
          <div className="sugbox">
            {suggestedQuestion &&
              suggestedQuestion.map((question) => {
                return (<span style={buttonStyle} onClick={(e) => {setMessageToChat(true);setMessage(e.target.textContent);}}>{question}</span>);})}
                
            {perUserErrorDisplay && (
              <div className="text-danger">{perUserError}</div>
            )}
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <div className="chating_foot">
              <form onSubmit={(e) => handleKeyPress(e)}>
                <input
                  type="text"
                  className="form-control"
                  aria-label="message…"
                  placeholder={messageType}
                  ref={chatMessageRef}
                  disabled={isDisable}
                  onInput={(e) => setMessage(e.target.value)}
                />
                <button
                  style={buttonStyle}
                  type="button"
                  className="button"
                  onClick={(e) => checkMessageLimit()}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-send" width="16" height="16" viewBox="0 0 24 24" stroke-width="1.5" stroke="#FFF" fill="none" stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M10 14l11 -11" />
                    <path d="M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5" />
                  </svg>
                </button>
                </form>
                <div className="mt-3">
                  <span><a href="http://www.dignitytransportation.net/chatbot.php?liveChat=1"target="_blank" >Chat with live agent.</a></span>
                </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default FreeChatbot;
